import React from 'react';
import { Box, Typography, Button, Modal } from '@mui/material';
import { tokens } from '../../Common/designTokens';

const InformativeModal = ({
  open,
  onClose,
  title = 'Information',
  message = '',
}) => {
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: tokens.colors.bodyBackgroundColor,
    border: `1px solid ${tokens.colors.bodyBorderColor50}`,
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="informative-modal">
      <Box sx={modalStyle}>
        <Typography variant="h6" sx={{ color: tokens.colors.fontColour, mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
          {title}
        </Typography>
        <Typography sx={{
          color: tokens.colors.fontColour85,
          mb: 3,
          textAlign: 'center',
          p: 0 // keep plain text (no background box)
        }}>
          {message}
        </Typography>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: "none",
            fontWeight: "700",
            backgroundColor: tokens.palette.primary,
            '&:hover': { backgroundColor: tokens.palette.primaryA80 },
            width: '140px'
          }}
        >
          Ok
        </Button>
      </Box>
    </Modal>
  );
};

export default InformativeModal;
